import { css } from 'styled-components';

export const scrollbarStyle = css`
  /*
  Looks like applying custom colors making sliders look werid in Chrome (Linux) and FF (Linux)
  So for now we use default scrollbars enforced to Dark theme.
    See body { color-scheme: dark; }
  Note that scrolls have different with on FF and Chrome. but it's neither possible to unite with
  scrollbar-with option - browsers ignoring it.  
  */

  /* scrollbar-width: thin; */
  /* scrollbar-color: #1a1a1a #3c3c3c; */
`;
